module.exports = __webpack_public_path__ + "img/Ansturm.f73f8057.svg";